export default __webpack_public_path__ + "static/media/mac_large.90056e8d.png";